<template>
    <a-modal
            title="商户入驻审批"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            @cancel="handleCancel"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <a-form-item
                        label="申请人"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.owner_name}}
                </a-form-item>
                <a-form-item
                        label="申请人联系方式"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.owner_phone}}
                </a-form-item>
                <a-form-item
                        label="商户名称"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.vendor_name}}
                </a-form-item>
                <a-form-item
                        label="商户地址"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.address}}
                </a-form-item>
                <a-form-item
                        label="商户联系方式"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.phone}}
                </a-form-item>
                <a-form-item
                        label="营业执照"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a :href="formData.license_url" target="_blank">查看</a>
                </a-form-item>
            </a-form>
        </a-spin>
        <template slot="footer">
            <a-button key="cancel" type="primary" @click="handleCancel">
                取消
            </a-button>
            <a-button key="submit" type="primary" @click="handleSubmit">
                通过
            </a-button>
        </template>
    </a-modal>
</template>

<script>
    export default {
        data () {
            return {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },
                visible: false,
                confirmLoading: false,

                form: this.$form.createForm(this),
                formData: {},
            }
        },
        props: {
            formType: ''
        },
        methods: {
            showForm(formData) {
                this.form.resetFields()
                this.visible = true
                this.formData = formData
            },

            handleSubmit () {
                let vm = this
                this.confirmLoading = true
                this.$confirm({
                    title: '通过审批',
                    okText: "确定",
                    cancelText: "取消",
                    content: h => <div style="color:red;">确定通过该商户的申请吗？</div>,
                        onOk() {
                            vm.confirmLoading = false
                            vm.visible = false
                            vm.$emit('accept', {id: vm.formData.id})
                        },
                        onCancel() {
                            vm.confirmLoading = false
                            console.log('Cancel');
                        },
                    class: 'test',
                });
            },
            handleCancel () {
                this.visible = false
            }
        },
    }
</script>
